import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-cxone-highlight-search-cell-renderer',
    templateUrl: './cxone-highlight-search-cell-renderer.component.html',
    styleUrls: ['./cxone-highlight-search-cell-renderer.component.scss']
})
export class CxoneHighlightSearchCellRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    value: string;
    searchFilter: string;
    minSearchLength = 1;

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted != null ? params.valueFormatted : params.value;
        this.searchFilter = this.params.context?.getFilterText();
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted != null ? params.valueFormatted : params.value;
        this.searchFilter = this.params.context?.getFilterText();
        return true;
    }
}
